import { NEW_RELIC_SCRIPT_SET } from './types';
export default {
  [NEW_RELIC_SCRIPT_SET](state, payload) {
    var currentState = state;
    currentState.newRelicScript = payload;
  }
};